import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { AuthService } from 'src/services/auth/authentication.service';
import { UserService } from 'src/services/user.service';
import Swal from 'sweetalert2';
import { DialogComponent } from '../../share/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { DialogService } from 'src/services/dialog.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm!: FormGroup;
  submitted: boolean = false;
  loginfails: boolean = false;
  isPasswordVisible = false;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authServices: AuthService,
    private userService: UserService,
    private dialogService: DialogService,
    public dialog: MatDialog
  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    localStorage.clear();
    this.initialforgotPasswordForm();
  }

  initialforgotPasswordForm() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', Validators.required],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.submitted && this.forgotPasswordForm.invalid) {
      this.loginfails = true;
    } else {
    this.loading = true;
    this.userService
        .forgotPassword(this.forgotPasswordForm.value.email.toLowerCase())
        .pipe(first())
        .subscribe({
          next: (res) => {
            this.loading = false;
            this.dialogService.openDialog({
              action: 'success',
              title: 'สำเร็จ',
              message: 'ส่ง Link ตั้งค่ารหัสผ่านใหม่เรียบร้อย กรุณาตรวจสอบ E-mail ของคุณ',
              multiBtn:false,
              hasBtn:true,
            }, () => this.router.navigate(['/auth/login']));
          },
          error: (error) => {
            let errors = error;
            this.loginfails = true;
            // Swal.fire({
            //   icon: 'error',
            //   title: 'Username or password incorrect',
            //   showConfirmButton: true,
            // });
          },
        });
    }
  }
  openDialog(data: any, callback: (data: boolean) => void): void {
    const dialogRef = this.dialog.open(DialogComponent, { width: '400px', data });
    dialogRef.afterClosed().subscribe(result => callback(result === 'confirm'));
  }
}
